import { convertTaskFromServer } from "./task";
const convertStageFromServer = (stage) => (Object.assign(Object.assign({}, stage), { stage_order: Number(stage.stage_order), tasks: (stage.tasks || []).map((task) => (Object.assign({}, convertTaskFromServer(task)))) }));
export { convertStageFromServer };
